import Modeler from 'bpmn-js/lib/Modeler.js'
import Moddle from 'bpmn-moddle'
import type ElementRegistry from 'diagram-js/lib/core/ElementRegistry.js'
import type EventBus from 'diagram-js/lib/core/EventBus.js'
// import * as BpmnJs from 'bpmn-js/dist/bpmn-modeler.development.js';
import { Injectable } from '@angular/core'
import { LgBpmnModdleExtensions } from '@lg/shared'
import {
	BpmnPropertiesPanelModule,
	BpmnPropertiesProviderModule,
} from 'bpmn-js-properties-panel'
import { LgPaletteProviderModule } from './bpmn-js/palette-provider.js'
import { LgReplacementProviderModule } from './bpmn-js/replacement-provider.js'
import { ProcessMessageDefinition, ProcessSignalDefinition } from '@lg/shared'
import { generateRandomString } from '@lg/shared'
import { LgContextPadProviderModule } from './bpmn-js/context-pad-provider.js'

@Injectable({
	providedIn: 'root',
})
export class ProcessEditorService {
	private _signalDefinitions: ProcessSignalDefinition[] | undefined
	private _messageDefinitions: ProcessMessageDefinition[] | undefined

	bpmnJs = new Modeler<{
		moddle: any
		modeling: any
		elementRegistry: ElementRegistry
		bpmnFactory: any
		commandStack: any
		eventBus: EventBus
		canvas: any
		propertiesPanel: BpmnPropertiesPanelModule
	}>({
		additionalModules: [
			BpmnPropertiesPanelModule,
			BpmnPropertiesProviderModule,
			LgPaletteProviderModule,
			LgReplacementProviderModule,
			LgContextPadProviderModule,
		],
		moddleExtensions: LgBpmnModdleExtensions,
	})
	moddle = this.bpmnJs.get('moddle')
	modeling = this.bpmnJs.get('modeling')
	bpmnFactory = this.bpmnJs.get('bpmnFactory')
	commandStack = this.bpmnJs.get('commandStack')
	eventBus = this.bpmnJs.get('eventBus')
	canvas = this.bpmnJs.get('canvas')
	propertiesPanel = this.bpmnJs.get('propertiesPanel')

	get elementRegistry() {
		return this.bpmnJs.get('elementRegistry')
	}
	get defitions() {
		return this.canvas.getRootElement().businessObject.$parent
	}
	get processEl() {
		return this.elementRegistry.get('Process_1')
	}

	getSignalDefinitions(): ProcessSignalDefinition[] {
		if (!this._signalDefinitions) {
			const definitions = this.canvas.getRootElement().businessObject.$parent
			this._signalDefinitions = definitions
				.get('rootElements')
				.filter((e) => e.$type == 'bpmn:Signal')
		}

		return this._signalDefinitions
	}

	addSignalDefinition(name: string) {
		const signal = this.moddle.create('bpmn:Signal', {
			id: `Signal_${generateRandomString(7, { alphabet: { upperCase: true, lowerCase: true, digits: true } })}`,
			name,
			broadcastOutsideProcess: false,
		} satisfies ProcessSignalDefinition)
		this.defitions.get('rootElements').push(signal)
		this._signalDefinitions = undefined
	}

	removeSignalDefinition(signal: ProcessSignalDefinition) {
		const index = this.defitions.get('rootElements').indexOf(signal)
		this.defitions.get('rootElements').splice(index, 1)
		this._signalDefinitions = undefined
	}

	getMessageDefinitions(): ProcessMessageDefinition[] {
		if (!this._messageDefinitions) {
			const definitions = this.canvas.getRootElement().businessObject.$parent
			this._messageDefinitions = definitions
				.get('rootElements')
				.filter((e) => e.$type == 'bpmn:Message')
		}

		return this._messageDefinitions
	}

	addMessageDefinition(name: string) {
		const message = this.moddle.create('bpmn:Message', {
			id: `Message_${generateRandomString(7, { alphabet: { upperCase: true, lowerCase: true, digits: true } })}`,
			name,
			tsType: 'string',
			broadcastOutsideProcess: false,
		} satisfies ProcessMessageDefinition)
		this.defitions.get('rootElements').push(message)
		this._messageDefinitions = undefined
	}

	removeMessageDefinition(message: ProcessMessageDefinition) {
		const index = this.defitions.get('rootElements').indexOf(message)
		this.defitions.get('rootElements').splice(index, 1)
		this._messageDefinitions = undefined
	}
}
